import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, Paper, Typography } from "@material-ui/core";

import { useInformacionComplementaria } from "../../context/InformacionComplementariaContext";

const ContinuarSinPorcentajeSectorEnfocado = () => {
    const {
        modalOpenPorcentajeSectorNoEnfocado,
        handleClosePorcentajeSectorNoEnfocado,
        handleClickConfirmarContinuarSinPorcenrajeSectorEnfocado,
        informacionComplementariaForm,
    } = useInformacionComplementaria();

    const { txtPorcentajeParticipacionSectorGobierno, txtPorcentajeParticipacionSectorPrivado } = informacionComplementariaForm;

    return (
        <Dialog
            open={modalOpenPorcentajeSectorNoEnfocado}
            onClose={handleClosePorcentajeSectorNoEnfocado}
            maxWidth="sm"
            fullWidth
            PaperComponent={(props) => <Paper square {...props} />}
        >
            <DialogTitle>Porcentajes del sector privado y sector gobierno</DialogTitle>
            <Box p={3}>
                <Grid container spacing={3} className="center">
                    <Grid item xs={12} className="center">
                        <Typography>
                            ¿Desea continuar sin modificar los valores de los porcentajes de participación en el sector privado y gobierno?
                        </Typography>
                    </Grid>

                    <Grid item xs={12} className="center">
                        <Typography>Los valores actuales son:</Typography>
                    </Grid>
                    <Grid item xs={12} className="center">
                        <Typography>Porcentaje sector privado: {txtPorcentajeParticipacionSectorGobierno.value}%</Typography>
                        <Typography>Porcentaje sector gobierno: {txtPorcentajeParticipacionSectorPrivado.value}%</Typography>
                    </Grid>
                </Grid>
            </Box>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={handleClosePorcentajeSectorNoEnfocado}>
                    Revisar
                </Button>
                <Button variant="contained" color="primary" onClick={handleClickConfirmarContinuarSinPorcenrajeSectorEnfocado}>
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContinuarSinPorcentajeSectorEnfocado;
